// Subscription status constants - matching backend constants
export const SUBSCRIPTION_STATUS = {
    APPROVED_FOR_SUBSCRIPTION: 'Approved for Subscription',
    ALLOCATING_SUBSCRIPTION: 'Allocating Subscription',
    ALLOCATING_SUBSCRIBERS: 'Allocating Subscribers',
    ACTIVE: 'Active',
    UPCOMING: 'Upcoming',
    CLOSED: 'Closed',
    ALLOCATED: 'Allocated',
    READY_FOR_ALLOCATION: 'Ready for Allocation',
    ALLOCATION_UPLOADED: 'Allocation Uploaded',
    ALLOCATION_FINALIZED: 'Allocation Finalized'
};

// Bond status constants - matching backend bond constants
export const BOND_STATUS = {
    DRAFT: 'Draft',
    PENDING_REVIEW: 'Pending Review',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    LISTED: 'Listed',
    ACTIVE: 'Active',
    READY_FOR_ALLOCATION: 'Ready for Allocation',
    ALLOCATION_UPLOADED: 'Allocation Uploaded',
    ALLOCATION_FINALIZED: 'Allocation Finalized',
    REDEMPTION_IN_PROCESS: 'Redemption in Process',
    REDEMPTION_COMPLETED: 'Redemption Completed',
    BURN_IN_PROCESS: 'Burn in Process',
    BURN_COMPLETED: 'Burn Completed',
    MATURED: 'Matured',
    IN_PROGRESS: 'In Progress'
};

// Bond type constants
export const BOND_TYPE = {
    CONVENTIONAL: 'Conventional',
    ISLAMIC: 'Islamic',
    SUKUK: 'Sukuk'
};

// Allocation status constants
export const ALLOCATION_STATUS = {
    UPLOADED: 'Allocation Uploaded',
    FINALIZED: 'Allocation Finalized'
};

// Payment status constants
export const PAYMENT_STATUS = {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    PROCESSING: 'Processing'
};

// FOP Transfer Request status constants
export const FOP_REQUEST_STATUS = {
    PENDING_APPROVAL: 'Pending Approval',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    COMPLETED: 'Completed'
};

// Maturity status constants
export const MATURITY_STATUS = {
    UPCOMING: 'Upcoming',
    DUE: 'Due',
    MATURED: 'Matured',
    EXTENDED: 'Extended'
};

// Source type constants
export const SOURCE_TYPE = {
    CSV_UPLOAD: 'CSV Upload',
    MANUAL_ALLOCATION: 'Manual Allocation'
};

// Transfer type constants
export const TRANSFER_TYPE = {
    PRIMARY_ALLOCATION: 'Primary Allocation',
    SECONDARY_TRANSFER: 'Secondary Transfer',
    OTC_SETTLEMENT: 'OTC Settlement'
};

// Status configuration for UI display
export const STATUS_CONFIG = {
    [SUBSCRIPTION_STATUS.UPCOMING]: {
        color: 'blue',
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-800'
    },
    [SUBSCRIPTION_STATUS.ACTIVE]: {
        color: 'green',
        bgColor: 'bg-green-100',
        textColor: 'text-green-800'
    },
    [SUBSCRIPTION_STATUS.CLOSED]: {
        color: 'gray',
        bgColor: 'bg-gray-100',
        textColor: 'text-gray-800'
    },
    [SUBSCRIPTION_STATUS.ALLOCATED]: {
        color: 'purple',
        bgColor: 'bg-purple-100',
        textColor: 'text-purple-800'
    },
    [SUBSCRIPTION_STATUS.APPROVED_FOR_SUBSCRIPTION]: {
        color: 'yellow',
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-800'
    },
    [SUBSCRIPTION_STATUS.ALLOCATING_SUBSCRIBERS]: {
        color: 'orange',
        bgColor: 'bg-orange-100',
        textColor: 'text-orange-800'
    },
    [SUBSCRIPTION_STATUS.READY_FOR_ALLOCATION]: {
        color: 'indigo',
        bgColor: 'bg-indigo-100',
        textColor: 'text-indigo-800'
    },
    [SUBSCRIPTION_STATUS.ALLOCATION_UPLOADED]: {
        color: 'green',
        bgColor: 'bg-green-100',
        textColor: 'text-green-800'
    },
    [SUBSCRIPTION_STATUS.ALLOCATION_FINALIZED]: {
        color: 'purple',
        bgColor: 'bg-purple-100',
        textColor: 'text-purple-800'
    }
};

// Bond type icons
export const BOND_TYPE_ICONS = {
    'Islamic': '☪',
    'Sukuk': '☪',
    'Conventional': '🏛',
    'Fixed Notes': '🏛'
};
